import { Card } from "@mantine/core";
import { CommentThread } from "@nodus/comments";
import { useAuthStore } from "@/lib/auth";

/** The company's comment thread with its landlord (staff see it on the tenant in the admin). */
export function LandlordNotes() {
  const tenantId = useAuthStore((s) => s.user?.tenant_id);
  if (!tenantId) return null;
  return (
    <Card withBorder padding="lg">
      <CommentThread target={{ app: "crm", model: "tenant", id: tenantId }} title="Notes from your landlord" />
    </Card>
  );
}
